export default "__VITE_ASSET__GZ_1f1XR__"